import { Employee } from './Employee';
import { MaximumWorkingHours } from './MaximumWorkingHours';
import { PreferredTimeOff } from './PreferredTimeOff';
import { ContractHours } from './ContractHours';
import { EmployeeRank } from './EmployeeRank';
import { Capability } from './Capability';
import { Availability } from './Availability';
import { TemporaryPreferredTimeOff } from './TemporaryPreferredTimeOff';
import { ManagerSettings } from './ManagerSettings';

/**
 * A class represents the full data of a particular employee.
 */
export class EmployeeDetails {
  employee: Employee;
  capabilities: Capability[];
  maximumWorkingHours: MaximumWorkingHours[];
  availabilities: Map<string, Availability[]>;
  preferredTimesOff: Map<string, PreferredTimeOff[]>;
  temporaryPreferredTimesOff: Map<string, TemporaryPreferredTimeOff>;
  employeeRanks: EmployeeRank[];
  contractHours: ContractHours[];
  managerSettings: ManagerSettings[];

  /**
   * @param employee the summarized information about a particular employee.
   * @param capabilities a list of employee capabilities.
   * @param maximumWorkingHours a list of employee's maximum working hours limitations.
   * @param availabilities a list of employee's availability to work.
   * @param preferredTimesOff a of days of a week when the employee prefers not to work.
   * @param temporaryPreferredTimesOff a list of specific dates when the employee prefers not to work.
   * @param employeeRanks a list of employee's ranks assignments.
   * @param contractHours a list of employee's contracted hour assignments.
   * @param managerSettings the manager settings for participating in sales.
   */
  constructor(
    employee: Employee,
    capabilities: Capability[],
    maximumWorkingHours: MaximumWorkingHours[],
    availabilities: Map<string, Availability[]>,
    preferredTimesOff: Map<string, PreferredTimeOff[]>,
    temporaryPreferredTimesOff: Map<string, TemporaryPreferredTimeOff>,
    employeeRanks: EmployeeRank[],
    contractHours: ContractHours[],
    managerSettings: ManagerSettings[]
  ) {
    this.employee = employee;
    this.capabilities = capabilities;
    this.maximumWorkingHours = maximumWorkingHours;
    this.availabilities = availabilities;
    this.preferredTimesOff = preferredTimesOff;
    this.temporaryPreferredTimesOff = temporaryPreferredTimesOff;
    this.employeeRanks = employeeRanks;
    this.contractHours = contractHours;
    this.managerSettings = managerSettings;
  }
}
